export const depositFrequency = {
  default: { value: 'default', text: 'One time deposit (Default)' },
  weekly: { value: 'weekly', text: 'Weekly' },
  bimonthly: { value: 'bimonthly', text: 'Twice a month (1st, 15th)' },
  monthly: { value: 'monthly', text: 'Monthly' },
};
